module.exports = __webpack_public_path__ + "static/media/sentiment_neutral.b4a45286.svg";